<template>
	<div class="listbox">
		<div class="title clearFix">
			<h2 >动漫游戏推荐</h2>
			<a to="/ip" data='{"ipTypeLevel1":"3"}'  @click="linkTo" class="more">查看更多 ></a>
		</div>
		<div class="listcont clearFix comiclist">
			<div class="list">
				<div class="item" v-for="item in comiclist">
					<a to="/detail" :data=' `{"iid":"${item.id}" }` ' class="link" @click="linkTo">
						<div class="picbox"><img :src="item.vertical_img"  alt="" class="pic"></div>
					</a>
					<a to="/detail" :data=' `{"iid":"${item.id}" }` ' class="link" @click="linkTo">
						<p class="tit">{{item.name}}</p>
						<p class="subtit">{{item.desc}}</p>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				comiclist:[
				]
			}
		},
		created(){
			 this.API.comic_list({limit:12},(res)=>{
				  this.comiclist = res.data
			 })
		},
		methods:{
			linkTo(e){
				let to = e.currentTarget.getAttribute("to")
				let data = e.currentTarget.getAttribute("data")
				this.utils.goto(this,to,JSON.parse(data))
			},
		}
	}
</script>

<style scoped>
	.comiclist .list{display: flex;flex-wrap: wrap;}
	.comiclist .list .item{width: 212px;margin-bottom: 36px;margin-right: 18px;}
	.comiclist .list .item:nth-child(6n){margin-right: 0;}
	.comiclist .list .picbox{width: 212px;height: 260px;border: 1px solid #E3E6EC;}
	.comiclist .list .picbox .pic{width: 100%;height: 100%;object-fit: cover;}
	.comiclist .list a.link{display: block;}
	.comiclist .list .tit{font-size: 16px;color: #222222;line-height: 22px;padding-top: 12px;padding-left: 8px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
	.comiclist .list .subtit{font-size: 14px;color: #888888;line-height: 20px;padding-top: 8px;padding-left: 8px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
</style>